import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import { RequireAuth } from 'components/require-auth';
import MissingPage from 'pages/missing-page';
import { LoginPayload } from 'types';
import userStore from 'store/UserStore';
import { routes } from 'routes/index';

const AppRouter = () => {
  const { email, password } = userStore.loginData;
  const authParams: LoginPayload = {
    email: email || '',
    password: password || '',
  };

  useEffect(() => {
    if (email !== '' && password !== '') {
      userStore.getAuthData(authParams);
    }
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        {routes.map(({ role, path, Component }) => (
          <Route
            key={path}
            element={<RequireAuth allowedRoles={role} />}
          >
            <Route
              path={path}
              element={<Component />}
            />
          </Route>
        ))}

        <Route
          path="*"
          element={<MissingPage />}
        />
      </Routes>
    </Router>
  );
};

const AppRouterObserver = observer(AppRouter);

export { AppRouterObserver as AppRouter };
